export default __webpack_public_path__ + "static/media/SF-Pro-Display-Medium.b85d841d.otf";